<template>
  <v-dialog v-model="dialog" scrollable max-width="90%" width="400px">
    <v-card>
      <v-card-title>
        {{ dialogTitle }}
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text v-if="groupMembers" style="max-height: 60vh">
        <v-list dense>
          <v-list-item v-for="user in groupMembers" :key="user.id">
            <v-list-item-content
              ><v-list-item-title>{{ user.name }}</v-list-item-title></v-list-item-content
            >
          </v-list-item>
        </v-list>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn text @click="dialog = false">{{ $t('close') }} </v-btn>

      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'GroupMemberDialog',
  props: {
    value: { type: Boolean, default: false },
    dialogTitle: String,
    groupMembers: Array, // Array of objects with an id and a name attribute
  },
  data() {
    return {
      dialog: this.value,
    };
  },
  watch: {
    value(newValue, oldValue) {
      this.dialog = newValue;
    },
    dialog(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$emit('input', newValue);
      }
    },
  },
};
</script>
